function vcUserOptions() {
    /// <summary>
    /// This class simplifies the getting and setting of user options. <br/>
    /// It inits the getData/updateData function of the hardcoded visual id. <br/>
    /// <br/>
    /// NOTE: Currently only boolean values got implemented - feel free to improve the functionality
    /// Author: ARF<br />
    /// Date: 3.7.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 3.7.2015                                                *<br />
    /// **********************************************************************<br />
    /// * - generates basic functionality                                    *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.source = "vcUserOptions";
    this.visual = new vcVisual();
    this.vcvid = 83;
}


vcUserOptions.prototype.getUserOptions = function (options, callback) {
    /// <summary>
    /// This function receives an optgroupid as json parameter and <br/>
    /// returns all found options for the given group and current user as datatable. 
    /// </summary>
    var me = this;
    try {
        window.VisualCoreService.getData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(options),
        function (result) {
            callback(result);
            return true;
        });
    } catch (ex) {
        writeError(me.source + '.JS.getUserOptions', ex);
    }
};

vcUserOptions.prototype.setUserOptions = function (options, callback) {
    /// <summary>
    /// This function receives an optgroupid, optid and bval (boolean value) as json parameter and <br/>
    /// stores it to the db. <br/>
    /// It returns true on success or false on error.
    /// </summary>
    var me = this;

    try {
        window.VisualCoreService.updateData(me.vcvid, '', getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(options),
            function (result) {
          
             callback(result);
             return true;
         });
    } catch (ex) {
        writeError(me.source + '.JS.setUserOptions', ex);
    }
};
